import { useState } from "react";

import Box from "@/components/Box";
import PartnerDashboardBox from "@/components/boxes/PartnerDashboardBox";
import { useOrganisationContext } from "@/contexts/organisations/OrganisationContext";
import EmptySearch from "@/tpo/EmptySearch";
import NothingToShow from "@/tpo/NothingToShow";

import AddTeamMemberForm from "./forms/AddTeamMemberForm";
import BusinessTemplate from "./ui/BusinessTemplate";
import TeamMembersList from "./ui/TeamMembersList";

export default function TeamMembers() {
  const { organisation } = useOrganisationContext();

  const [membersRefetch, setMembersRefetch] = useState(0);
  return (
    <BusinessTemplate active="team_members">
      {organisation.teamMembersEnabled ? (
        <>
          <PartnerDashboardBox gap={0}>
            <TeamMembersList refetch={membersRefetch} />
          </PartnerDashboardBox>
          <PartnerDashboardBox>
            <AddTeamMemberForm onSuccess={() => setMembersRefetch(Math.random())} />
          </PartnerDashboardBox>
        </>
      ) : (
        <NothingToShow
          header="Team members disabled"
          bodyCopy="Please contact info@regeneruslabs.com if you would like to enable team members in your organisation."
          mx="auto"
        />
      )}
    </BusinessTemplate>
  );
}
